module.exports = __webpack_public_path__ + "assets/img/41914baf41dd6be658ce286303e4585e.svg";